import React from "react";
import {
  Controller,
  FieldErrors,
  Control,
  FieldError,
  FieldErrorsImpl,
  Merge,
} from "react-hook-form";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { SxProps, Theme } from "@mui/material";
import { getTextAfterLastDot } from "../utils/utils";

export interface Option {
  value: string;
  label: React.ReactNode;
}

interface AutocompleteSelectProps {
  fieldName: string;
  label: string;
  control: Control<any, any>;
  errors:
    | FieldErrors<any>
    | FieldErrorsImpl<any>
    | Merge<FieldError, FieldErrorsImpl<any>>
    | undefined;
  options: Option[];
  fontSize?: number;
  width?: number | string;
  size?: "small" | "medium";
  style?: React.CSSProperties;
  sx?: SxProps<Theme>;
  isFromArray?: boolean;
}

export default function SelectInput(props: AutocompleteSelectProps) {
  const {
    sx,
    fieldName,
    control,
    fontSize,
    errors,
    width,
    label,
    options,
    isFromArray,
    ...otherProps
  } = props;

  const errorMessage = !isFromArray
    ? ((errors &&
        (typeof errors[fieldName]?.message === "string"
          ? errors[fieldName]?.message
          : undefined)) as string | undefined)
    : ((errors &&
        (typeof errors[getTextAfterLastDot(fieldName)]?.message === "string"
          ? errors[getTextAfterLastDot(fieldName)]?.message
          : undefined)) as string | undefined);

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => (
        <Autocomplete
          {...otherProps}
          options={options}
          getOptionLabel={(option: Option) => (option.label ?? "").toString()}
          sx={{ ...sx }}
          renderInput={(params) => (
            <TextField
              {...params}
              style={props.style}
              size="small"
              sx={{
                // width: width ?? "200px",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",
                },
              }}
              inputProps={{
                ...params.inputProps,
                style: {
                  fontSize: fontSize ?? 16,
                },
              }}
              InputLabelProps={{
                style: { fontSize: fontSize ?? 16 },
              }}
              label={
                label
              }
              error={
                !isFromArray
                  ? errors && !!errors[fieldName]
                  : errorMessage
                  ? true
                  : false
              }
              helperText={errorMessage}
            />
          )}
          value={
            field.value
              ? options.find((option) => option.value === field.value)
              : null
          }
          onChange={(_, newValue: Option | null) => {
            console.log("Novo Valor Selecionado:", newValue);
            field.onChange(newValue?.value || "");
          }}
        />
      )}
    />
  );
}
